import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Hero from "../sections/Hero";
import HomeChallenge from "../sections/HomeChallenge";
import HomeIntroducing from "../sections/HomeIntroducing";
import HomeCapabilities from "../sections/HomeCapabilities";
import HomeJourney from "../sections/HomeJourney";
import HomeDemo from "../sections/HomeDemo";
import HomeTrust from "../sections/HomeTrust";
import HomeSectors from "../sections/HomeSectors";
import ClosingCta from "../sections/ClosingCta";
import ContactSection from "../sections/ContactSection";
import { usePageSeo } from "../lib/seo";

const HomePage = () => {
    usePageSeo(
        "BuildEase | South Africa's Residential Construction Intelligence Platform",
        "BuildEase helps South African homeowners understand architectural plans, construction costs, contractor quotations and building requirements. Build with clarity, not guesswork.",
    );

    return (
        <div className="min-h-screen bg-ink text-white">
            <Navbar />
            <main>
                <Hero />
                <HomeChallenge />
                <HomeIntroducing />
                <HomeCapabilities />
                <HomeJourney />
                <HomeDemo />
                <HomeTrust />
                <HomeSectors />
                <ClosingCta />
                <ContactSection />
            </main>
            <Footer />
        </div>
    );
};

export default HomePage;
